<template>
<div class="main-body">
  <div class="card">
      <div class="card-body">
          <div class="row">
              <div class="col-sm-5">
                  <h4 class="card-title mb-0">
                    Marketplace Store Contact Message <small class="text-muted">stores</small>
                  </h4>
              </div><!--col-->

              <div class="col-sm-7">
                  <header-button></header-button>
              </div><!--col-->
          </div><!--row-->

          <div class="row mt-4">
              <div class="col">
                  <div class="table-responsive">
                      <table class="table">
                        <colgroup>
                          <col width="5%">
                          <col width="10%">
                          <col width="10%">
                          <col width="10%">
                          <col width="40%">
                          <col width="10%">
                        </colgroup>
                        <thead>
                          <tr>
                            <th>No.</th>
                            <th>{{ $t('marketplace.marketplace_store') }}</th>
                            <th>{{ $t('marketplace.marketplace_courier') }}</th>
                            <th>{{ $t('marketplace.contact.message_type') }}</th>
                            <th>{{ $t('marketplace.contact.contact_user_message') }}</th>
                            <th>{{ $t('marketplace.store.operation') }}</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(contactMessage, index) in marketplaceContactMessages" :key="index">
                            <td>{{ index+1 }}</td>
                            <td>{{ contactMessage.marketplace_store_name }}</td>
                            <td>{{ contactMessage.marketplace_courier_name }}</td>
                            <td>{{ contactMessage.message_type }}</td>
                            <td>{{ contactMessage.contact_user_message }}</td>
                            <td>
                              <router-link :to="{ path: '/marketplace/contact/' + contactMessage.id + '/edit' }">
                                <b-button variant="primary btn-sm ml-1"><i class="fa fa-pencil"></i></b-button>
                              </router-link>
                               <b-button variant="danger btn-sm ml-1" @click.stop.prevent="handleDelete(contactMessage.id)"><i class="fa fa-trash"></i></b-button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                  </div>
              </div><!--col-->
          </div><!--row-->
      </div><!--card-body-->
  </div><!--card-->
  <loading-panel v-if="showLoadingPanel"></loading-panel>
</div>
</template>

<script>
import HeaderButton from '@/views/components/marketplace/contact/HeaderButton'
import LoadingPanel from '@/components/LoadingPanel'

export default {
  name: 'ContactMessages',
  components: {
    HeaderButton,
    LoadingPanel
  },
  mounted () {
    this.axios.get('/marketplace/contact-message').then(response => {
      this.marketplaceContactMessages = response.data
    }).catch(error => {
      console.log(error)
    })
  },
  data () {
    return {
      marketplaceContactMessages: [],
      showLoadingPanel: false
    }
  },
  methods: {
    handleDelete (shiperId) {
      this.$swal({
        title: this.$t('operation.delete.title'),
        text: this.$t('operation.delete.text'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('operation.delete.confirm_button')
      }).then((result) => {
        if (result.value) {
          this.showLoadingPanel = true
          this.axios.delete('/marketplace/contact-message/' + shiperId).then(() => {
            // this.showLoadingPanel = false
            // this.$router.push('/marketplace/store')
            location.reload()
          }).catch(error => {
            this.showLoadingPanel = false
            this.$swal({
              icon: 'error',
              title: error.data.message
            })
          })
        }
      })
    }
  }
}
</script>
